import { ActiveElement, CategoryScale, Chart as ChartJS, ChartData, ChartOptions, LinearScale, LineController, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import { ChartEvent } from 'chart.js/dist/core/core.plugins';
import { Line } from 'react-chartjs-2';
import SmashSpinner from '../SmashSpinner/SmashSpinner';
ChartJS.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip);

interface Props {
    title?: string;
    unit?: string;
    displayUnit?: boolean;
    xValues?: Array<string | number>;
    yValues?: Array<number>;
    tooltipLabel?: string;
    onHover: (x: string | number, y: number) => void
}


const Chart = ({ title, unit, tooltipLabel, xValues, yValues, displayUnit, onHover }: Props) => {

    function buildData(): ChartData<'line', number[], string | number> {
        return {
            labels: xValues!,
            datasets: [
                {
                    label: tooltipLabel,
                    backgroundColor: "rgb(255, 99, 132)",
                    borderColor: "#562aa2",
                    pointBackgroundColor: "#562aa2",
                    data: yValues!,
                }
            ]
        }
    }

    function buildOptions(): ChartOptions<'line'> {
        return {
            responsive: true,
            interaction: {
                mode: 'index',
                intersect: false,
            },
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: title,
                },
            },
            scales: {
                x: {
                    beginAtZero: true,

                },
                y: {
                    beginAtZero: true,
                    ticks: {
                        stepSize: 1,
                        callback: function (value, index, values) {
                            if (displayUnit && !!unit) {
                                return `${value} ${unit}`;
                            }
                            return value;
                        }
                    }
                },
            },
            onHover: (event, activeElement) => handleOnHover(event, activeElement),
        };
    }

    function handleOnHover(event: ChartEvent, activeElements: ActiveElement[]) {
        if (xValues && yValues && activeElements?.length) {
            return onHover(xValues[activeElements[0]?.index], yValues[activeElements[0]?.index]);
        }
    }

    return (
        <div className="d-flex justify-content-center" style={{ position: "relative", height: "200px", width: "450px" }}>
            {xValues && yValues && <Line data={buildData()} options={buildOptions()} />}
            {(!xValues || !yValues) && <SmashSpinner />}
        </div>
    )
}

export default Chart